import { useEffect, useState } from 'react';
export default function useIsPWA() {
  const [isPWA, setIsPWA] = useState(false);
  useEffect(() => {
    const isInStandaloneMode = () => {
      var _a;
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || ((_a = document === null || document === void 0 ? void 0 : document.referrer) === null || _a === void 0 ? void 0 : _a.includes('android-app://'));
    };
    if (isInStandaloneMode()) {
      setIsPWA(true);
    }
  }, []);
  return isPWA;
}